import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const terminateOrder = async (
  client_id: string,
  order_id: string,
  trip_id: string
): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.base_url}/order/${client_id}/terminate-order/`;
    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({ trip_id, order_id })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      console.log('throw error.');
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
